import { Agency, agencyBasic } from '@app/models';
import { DictionaryEntity } from '@app/pcs/models';
import { PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { AppointmentStatus } from '@dossier/models';
import { gql } from 'apollo-angular';

export interface ResponsibleRuPaPmData {
  doneEditing?: boolean;
}

export interface ResponsibleRu {
  id?: number;
  agency?: Agency;
  editAccess?: boolean;
  paPmData?: ResponsibleRuPaPmData;
  status?: DictionaryEntity<AppointmentStatus>;
}
export const responsibleRuMapper = new PropertyNameMapper({
  agency: 'agencyId',
  status: 'status',
  editAccess: 'transferEditAccess',
  doneEditing: 'doneEditing'
});

export const responsibleRu = gql`
  fragment responsibleRu on ResponsibleRu {
    agency {
      ...agencyBasic
    }
    editAccess
    paPmData {
      doneEditing
    }
    status {
      id
      description
    }
  }
  ${agencyBasic}
`;
